import axios from 'axios';
export const fetchRating = ({
  url,
  hotelId,
  page,
  sort,
  traveledAs,
  splitTreatment,
  lang,
  src
}) => axios.get(`${url}/v1/ratings/hotel/${hotelId}`, {
  params: {
    from: (page - 1) * 10,
    size: 10,
    traveledAs,
    sort,
    splitTreatment,
    lang,
    src
  }
}).then(({
  data
}) => data).catch(() => undefined);